
<div class="row">
    <div class="col">
        <label>{{ label }}</label>
        <hr class="mt-0 mb-2"/>

        @if (!showRte) {
<div [innerHTML] = "notes || 'Write description here..'"
            class="rte-placeholder border-0 w-100 h-100" 
            (click)="showRte = true" 
        ></div>
}

        @if (showRte) {
<ejs-richtexteditor #notesRte
           
            id='defaultRTE' 
            [enableResize]="false" 
            height='200px'
            [placeholder]="'Write description here..'"
            [value]="notes"
            [insertImageSettings]='insertImageSettings' 
            (change)="notes = notesRte.value; notesChanged.emit(notes)"
            (blur)="blur($event)"
        ></ejs-richtexteditor>
}
    </div>
</div>